class CustomizeProductSwiper extends HTMLElement {
  connectedCallback() {
      const _this = this;
      function init() {
          const container = _this.querySelector('.customize-product__swiper');
          if (!container) return;

          const slidesCount = container.querySelectorAll('.swiper-slide').length;
          const showNav = slidesCount > 4;
          if (!showNav) {
            const prev_button = container.querySelector('.swiper-button-prev');
            if (prev_button) prev_button.style.display = 'none';
            const next_button = container.querySelector('.swiper-button-next');
            if (next_button) next_button.style.display = 'none';
          } else { 
            const prev_button = container.querySelector('.swiper-button-prev');
            if (prev_button) prev_button.style.display = 'block';
            const next_button = container.querySelector('.swiper-button-next');
            if (next_button) next_button.style.display = 'block';
          }

          // 避免重复初始化
          if (container.swiper) container.swiper.destroy(true, true);

          new Swiper(container, {
              speed: 500,
              spaceBetween: 20,
              grabCursor: true,
              watchOverflow: true,
              navigation: {
                  nextEl: _this.querySelector('.swiper-button-next'),
                  prevEl: _this.querySelector('.swiper-button-prev'),
              },
              breakpoints: {
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                    grid: { rows: 2, fill: 'row' },  // 移动端：2 列 × 2 行
                    slidesPerGroup: 4                 // 每次滑动一个“整页”（2×2）
                  },
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                    grid: { rows: 2, fill: 'row' },  // 移动端：2 列 × 2 行
                    slidesPerGroup: 4                 // 每次滑动一个“整页”（2×2）
                  },
                  1024: { slidesPerView: 4, spaceBetween: 20 },
                  1920: { slidesPerView: 4, spaceBetween: 20 }
              },
              pagination: {
                  el: '.customize-product__swiper .swiper-pagination',
                  clickable: true,         // 允许点击跳转
                  type: 'bullets'          // 默认就是 bullets
              }
          });
      }

      // 首次与编辑器热加载
      if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
      } else {
          init();
      }
      document.addEventListener('shopify:section:load', function (e) {
          if (e && e.detail && e.detail.sectionId === SID) init();
      });
  }
}


// 注册自定义元素
reg("customize-product-swiper", CustomizeProductSwiper);